import * as React from 'react'
import { useCallback } from 'react'
import { MatchPairProps } from '../../typings'
import { SelectionHeader } from '../../atoms'
import { LocationMatch } from '@user/store/entityLocations'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'
import { SmallLocationCard, EditCardFooter } from '@user/components/Location'

type Props = MatchPairProps & {
  match: LocationMatch & {
    createNewLocation: true
  }
}

export const CreateBody: React.FC<Props> = (props) => {
  const {
    location,
    formDispatch,
    state: { saving },
  } = props

  const { isInvalid, branch } = location

  const [open, toggleOpen] = useToggleBoolean()

  const onEditClick = useCallback(
    () => formDispatch({ type: 'edit', payload: location }),
    [formDispatch, location],
  )

  return (
    <SmallLocationCard
      {...props}
      isEditable={false}
      open={open}
      toggleOpen={toggleOpen}
      hidePopover
      header={<SelectionHeader {...props} />}
      footer={
        <EditCardFooter
          disabled={saving}
          isInvalid={isInvalid}
          onClick={onEditClick}
          branch={branch ?? ''}
        />
      }
    />
  )
}
CreateBody.displayName = 'CreateBody'
